import {TARGET_TYPES} from '@/utils/constants/saleTargetConstants';

export const getStepConfig = (targetType) => {
  if (
    targetType === TARGET_TYPES.EarlyPaymentTarget ||
    targetType === TARGET_TYPES.DropSizeTarget ||
    targetType === TARGET_TYPES.RackChallenge ||
    isCdaSuperTargetType(targetType)
  ) {
    return {
      steps: 3,
      titles: [{title: 'Setup'}, {title: 'Display Content'}, {title: 'Review'}]
    };
  }
  return {
    steps: 4,
    titles: [
      {title: 'Setup'},
      {title: 'Display Content'},
      {title: 'Products'},
      {title: 'Review'}
    ]
  };
};

export const isEarlyPaymentTargetType = (targetType) =>
  targetType === TARGET_TYPES.EarlyPaymentTarget;

export const isLinkedTargetType = (targetType) =>
  targetType === TARGET_TYPES.EarlyPaymentTarget ||
  targetType === TARGET_TYPES.DropSizeTarget;

export const isRackChallengeType = (targetType) =>
  targetType === TARGET_TYPES.RackChallenge;

export const isCdaSuperTargetType = (targetType) =>
  Boolean(targetType) && targetType === TARGET_TYPES.CdaSuperTarget;
